export default __webpack_public_path__ + "assets/img_calculator_own_settings-62b5e8e9.jpg";